import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BannerModule, ButtonModule, TagsModule } from '@xref/xref-lib';
import { QuestionnaireListComponent } from './questionnaire-list.component';
import { SortModule } from 'src/app/components/sort/sort.module';
import { SearchModule } from 'src/app/components/search/search.module';
import { AppPaginationModule } from 'src/app/components/pagination/pagination.module';
import {LoaderModule} from "../../../loader/loader.module";


@NgModule({
  declarations: [QuestionnaireListComponent],
  imports: [
    CommonModule,
    TooltipEllipsifyModule,
    TooltipModule.forRoot(),
    BannerModule,
    ButtonModule,
    TagsModule,
    TagsModule,
    SortModule,
    SearchModule,
    AppPaginationModule,
    LoaderModule
  ],
  exports: [QuestionnaireListComponent],
})
export class QuestionnaireListModule { }
